var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseThemeComponent',_vm._g(_vm._b({attrs:{"name":`Menu/${_vm.name}`}},'BaseThemeComponent',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }